import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Microsoft Teams Send Message v1 Configuration Validator
 * Validates Microsoft Teams message configuration including connection, team, channel, and content
 */
export const Microsoft_Teams_Send_Bot_Message_1_ConfigValidator = z.object({
    microsoftTeamsConnection: requiredString('Microsoft Teams Connection is required'),
    team: requiredString('Team is required'),
    channel: requiredString('Channel is required'),
    message: requiredString('Message is required')
});
//# sourceMappingURL=microsoft-teams-send-bot-message-1.js.map